import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Tablet } from '../../../models/tablet';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { StockLevelReportService } from '../../../services/stock-level-report.service';
import { ModalService } from '../../../services/modal.service';
import { CheckUserType } from '../../../models/checkUserType';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-stock-level-report',
  templateUrl: './stock-level-report.component.html',
  styleUrls: ['./stock-level-report.component.css']
})
export class StockLevelReportComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;
  modalService: ModalService;

  customerTypes: Customer_Type[];
  users: Tablet[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    pda_User_ID: 0,
    start_Date: moment().add(-2, 'months').toDate(),
    end_Date: moment().toDate(),
    quick_Search: ""
  };

  availableOptions: string[] = [
    'Location',
    'Product Type',
    'Cylinder Size',
    'Stock'
  ];

  selectedOptions: string[] = [
    'Location',
    'Product Type',
    'Cylinder Size',
    'Stock'
  ];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  showStockLevelLocation: boolean = false;
  location_Id: string;
  product_Type_Id: string;
  cyl_Size_Id: string;


  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, public stockLevelReportService: StockLevelReportService, private columnService: ColumnService,
    customerTypeService: CustomerTypeService, public router: Router, modalService: ModalService, ) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
    this.modalService = modalService;
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }
      
      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

      });

      this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  openStockLocationPopup(row) {
    this.showStockLevelLocation = true;
    this.location_Id = row.location_ID;
    this.product_Type_Id = row.product_Type_ID;
    this.cyl_Size_Id = row.cyl_Size_ID;


    this.modalService.open('popup-stock-level-location');
  }

  closeStockLocationPopup() {
    this.showStockLevelLocation = false;
    this.modalService.close('popup-stock-level-location');
  }

  // ###################################
  // Filters
  // ###################################
  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.stockLevelReportService.getResults(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.stockLevelReportService.getExcel(this.filter.company_Id, this.filter.location_Id).then((data) => {
        importedSaveAs(data, 'Stock-level.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "stockLevelReport").then((data) => {
      if (data.columns != null) {  
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "stockLevelReport", this.selectedOptions).then((data) => {
    });
  }
}

